module.exports = __webpack_public_path__ + "static/media/nav.1613cf44.svg";